export default __webpack_public_path__ + "static/media/imgEscolhas.c62bf83a.png";